const toggleDescriptions = {
    inventory: "Allows Inventory Deduction for Food Cost and Inventory Restocking",
    "auto print kitchen": "Allows auto printing of order slips per Order for the Kitchen View in KDS",
    "auto print checked items kitchen": "Allows auto printing of checked Menu Items for the Kitchen View in KDS",
    "service charge": "Allows service charges for Dine-In Transactions",
    "out of stock": "Allows Out of Stock Logic to occur when Ingredient is Insufficient for an Order",
    "foh gross sales": "Allows Front of House to have a Counter for Gross Sales Goal for a given day",
    "boh gross sales": "Allows Back of House to have a Counter for Gross Sales Goal for a given day",
  };
  
export default toggleDescriptions;
  